var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            width: "400px",
            title: `Edit ${_vm.title} Customer`,
            visible: _vm.dialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { "element-loading-text": "Loading..." },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "se-name",
                      attrs: { prop: "name", label: "Customer Name：" },
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.form.name))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "userIds", label: _vm.title } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: `Please select ${_vm.title}`,
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.form.userIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "userIds", $$v)
                            },
                            expression: "form.userIds",
                          },
                        },
                        _vm._l(_vm.crpList, function (item, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: item.TAName, value: item.TAID },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v(" " + _vm._s(_vm.saving ? "Saving" : "Save") + " ")]
                  ),
                  _c("el-button", { on: { click: _vm.onClosed } }, [
                    _vm._v("Cancel"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }